import { FileText, DollarSign, Key, Calculator, Lock, Car, Home, Building, Briefcase, Heart, CreditCard, Shield, Smartphone, Mail, Globe, Users, Folder } from "lucide-react";
import type { LucideIcon } from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  FileText,
  DollarSign,
  Key,
  Calculator,
  Lock,
  Car,
  Home,
  Building,
  Briefcase,
  Heart,
  CreditCard,
  Shield,
  Smartphone,
  Mail,
  Globe,
  Users,
  Folder,
};

export type IconName = keyof typeof iconMap;

export function getIcon(iconName: string): LucideIcon {
  return iconMap[iconName as IconName] || FileText;
}
